import { getStoryblokApi } from "@storyblok/react";
import axios from "axios";

class SearchUtils {
  static async getCachedOrStoryblokSearch(
    query: string | null,
    itemsPerPage: number,
    page: number
  ) {
    try {
      return await this.getSearch(query, itemsPerPage, page);
    } catch {
      return await this.getStroyblokSearch(query, itemsPerPage, page);
    }
  }

  static getSearch = (
    query: string | null,
    itemsPerPage: number,
    page: number
  ) => {
    return axios.get(
      `${window.location.origin}/cache-api/api/storyblok/cache/`,
      {
        params: {
          version: "published",
          per_page: itemsPerPage,
          component: "Page",
          excludeFromGlobalSearch: false,
          query_filter: query,
          page: page,
        },
      }
    );
  };

  static getStroyblokSearch = (
    query: string | null,
    itemsPerPage: number,
    page: number
  ) => {
    return getStoryblokApi().getStories({
      token: process.env.REACT_APP_STORYBLOK_ACCESS_TOKEN,
      version: "published",
      page: page,
      per_page: itemsPerPage,
      resolve_relations: "ShowcasePanel.entity",
      filter_query: {
        component: { in: "Page" },
        excludeFromGlobalSearch: { in: false },
        __or: [
          {
            shortTitle: {
              like: `*${query}*`,
            },
          },
          {
            standfirst: {
              like: `*${query}*`,
            },
          },
        ],
      },
    });
  };
}

export default SearchUtils;
